import { render, staticRenderFns } from "./SwapSendToModal.vue?vue&type=template&id=c97b5be8&scoped=true&"
import script from "./SwapSendToModal.vue?vue&type=script&lang=js&"
export * from "./SwapSendToModal.vue?vue&type=script&lang=js&"
import style0 from "./SwapSendToModal.vue?vue&type=style&index=0&id=c97b5be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97b5be8",
  null
  
)

export default component.exports